module.exports = "/assets/data/5180f4eaf08b4c3360d7df251f539f8b-NN3.data.json";